import React from 'react';
import { KeyboardAvoidingView, Platform, SafeAreaView, ScrollView, StyleSheet, View, ViewStyle } from 'react-native';

import { colors } from '../Styles';

type MNOHSSafeViewProps = {
  /** A style to apply to the highest-level wrapper view. */
  style?: ViewStyle;

  /**
   * A style to apply to the lowest-level wrapper view. (applied
   * to the the ScrollView's `contentContainerStyle` prop).
   */
  scrollViewContentContainerStyle?: ViewStyle;

  /** Set to `true` to disable safe area protection. Default is false. */
  disableSafeArea?: boolean;
};

type KeyboardViewProps = {
  /** A style to apply to the keyboard wrapper view. */
  style?: ViewStyle;

  /**
   * A style to apply to the lowest-level wrapper view. (applied
   * to the the ScrollView's `contentContainerStyle` prop).
   */
  scrollViewContentContainerStyle: ViewStyle;

  /** Children to place adjacent to the scroll view, but within the safe area and keyboard avoiding view. */
  childrenAdjacentToScrollView?: React.ReactNode;
};

const KeyboardView: React.FC<KeyboardViewProps> = props => {
  return (
    <KeyboardAvoidingView
      style={{ ...styles.fullWidthAndHeight, ...props.style }}
      // This extra wrapper isn't necessary on Android (we get the desired avoiding behavior out of the box).
      // So, only enable on iOS.
      enabled={Platform.OS === 'ios'}
      behavior={'padding'}>
      <View style={styles.fullWidthAndHeight}>
        <ScrollView
          style={styles.scrollView}
          contentContainerStyle={props.scrollViewContentContainerStyle}
          bounces={false}>
          {props.children}
        </ScrollView>
      </View>
    </KeyboardAvoidingView>
  );
};

/**
 * A wrapper component. Respects the safe area, the keyboard, and provides scrolling if it's children expand
 * beyond its border.
 */
export const MNOHSSafeView: React.FC<MNOHSSafeViewProps> = props => {
  if (props.disableSafeArea === true) {
    return (
      <KeyboardView
        style={{ backgroundColor: colors.white, ...props.style }}
        scrollViewContentContainerStyle={{ ...props.scrollViewContentContainerStyle }}>
        {props.children}
      </KeyboardView>
    );
  } else {
    return (
      <SafeAreaView style={{ backgroundColor: colors.white, ...props.style }}>
        <KeyboardView scrollViewContentContainerStyle={{ ...props.scrollViewContentContainerStyle }}>
          {props.children}
        </KeyboardView>
      </SafeAreaView>
    );
  }
};

const styles = StyleSheet.create({
  scrollView: {
    width: '100%',
  },
  fullWidthAndHeight: {
    width: '100%',
    height: '100%',
  },
});
